import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DataService {
    constructor(private http: HttpClient) {}

    public getFrequencies(businessId: string, range: any) {
        return this.http.get(
            `${environment.backendDomain}/localbusinesses/${businessId}/customers/allfrequencies`,
            { params: range } as never
        );
    }

    public getJourney(businessId: string, range: any) {
        return this.http.get(
            `${environment.backendDomain}/dashboard/journey/business/${businessId}`,
            { params: range } as never
        );
    }

    public getBoxesByBusiness(id: string | number): Observable<any[]> {
        return this.http.get<any[]>(
            `${environment.backendDomain}/localbusinesses/${id}/boxes`
        );
    }

    public getJourneyBoxes(id: string | number): Observable<any[]> {
        return this.http.get<any[]>(
            `${environment.backendDomain}/localbusiness/${id}/journeyBoxes`
        );
    }
}
